import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const CourseHeader = ({ course, onBack, onPublish }) => {
  const navigate = useNavigate();
  const { courseId } = useParams();

  const getStatusColor = (status) => {
    switch (status) {
      case 'published': return 'bg-green-100 text-green-800 border-green-200';
      case 'draft': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'pending': return 'bg-blue-100 text-blue-800 border-blue-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const handleEditCourse = () => {
    navigate(`/courses/create?edit=${courseId}`);
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 sm:mb-8">
      <div className="flex items-center space-x-4 mb-4 sm:mb-0">
        <button
          onClick={onBack}
          className="flex items-center space-x-2 px-4 py-2 bg-white text-gray-700 rounded-xl font-semibold transition-all duration-300 hover:bg-gray-50 hover:scale-105 hover:shadow-lg"
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span>Back to Courses</span>
        </button>
        
        <span className={`px-3 py-1 rounded-full text-sm font-semibold border ${getStatusColor(course.status)}`}>
          {course.status.charAt(0).toUpperCase() + course.status.slice(1)}
        </span>
      </div>

      <div className="flex space-x-3">
        <button 
          onClick={handleEditCourse}
          className="px-4 sm:px-6 py-2 bg-green-500 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-green-600 hover:scale-105 flex items-center space-x-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          <span>Edit Course</span>
        </button>
        
        {course.status !== 'published' && (
          <button 
            onClick={onPublish}
            className="px-4 sm:px-6 py-2 bg-blue-500 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-blue-600 hover:scale-105"
          >
            Publish Course
          </button>
        )}
      </div>
    </div>
  );
};

export default CourseHeader;